import React, { useState } from "react";import logo from "../../Assets/EMEI logo.jpeg";
import admin_img from "../../Assets/dadaa.jpg";
import "../../Pages/Dashboard/admin_home.css";

import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = ({ collapsed, setCollapsed }) => {
const [showMeetingModal, setShowMeetingModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={`admin_sidebar ${collapsed ? "collapsed" : ""}`}>

      {/* TOGGLE BUTTON */}
      <div
        className="admin_toggle"
        onClick={() => setCollapsed(!collapsed)}
      >
        {collapsed ? "›" : "‹"}
      </div>

      {/* LOGO */}
      <div className="admin_logoBox">
        <div className="admin_logoCircle">
          <img src={logo} alt="EMEI logo" />
        </div>

        {!collapsed && (
          <h2 className="admin_logoText">EMEI</h2>
        )}
      </div>

      {/* USER */}
      <div className="admin_user">
        <div className="admin_avatar">
          <img src={admin_img} alt="Admin" />
        </div>

        {!collapsed && (
          <div className="admin_userInfo">
            <h4>Sayan Da</h4>
            <span>Admin</span>
          </div>
        )}
      </div>

      {/* MENU */}
      <ul className="admin_menu">

        <li
          className={`admin_sidebar_item ${
            location.pathname === "/dashboard" ? "active" : ""
          }`}
          onClick={() => navigate("/dashboard")}
        >
          <span className="icon">▦</span>
          {!collapsed && "Dashboard"}
        </li>

        <li
          className={`admin_sidebar_item ${
            location.pathname === "/admin/courses" ? "active" : ""
          }`}
          onClick={() => navigate("/admin/courses")}
        >
          <span className="icon">🎓</span>
          {!collapsed && "Courses"}
        </li>
        <li
  className={`admin_sidebar_item ${
    location.pathname === "/jobs" ? "active" : ""
  }`}
  onClick={() => navigate("/jobs")}
>
  <span className="icon">💼</span>
  {!collapsed && "Jobs"}
</li>

<li
  className={`admin_sidebar_item ${
    location.pathname === "/students" ? "active" : ""
  }`}
  onClick={() => navigate("/students")}
>
  <span className="icon">👥</span>
  {!collapsed && "Students"}
</li>


        <li
          className={`admin_sidebar_item ${
            location.pathname === "/settings" ? "active" : ""
          }`}
          onClick={() => navigate("/settings")}
        >
          <span className="icon">⚙️</span>
          {!collapsed && "Settings"}
        </li>
        <li
  className={`admin_sidebar_item ${
    location.pathname === "/admin-gallery" ? "active" : ""
  }`}
  onClick={() => navigate("/admin-gallery")}
>
  <span className="icon">🖼️</span>
  {!collapsed && "Gallery"}
</li>
          
      </ul>
<button
  className="admin_meeting_btn"
  onClick={() => setShowMeetingModal(true)}
>
  <span>📹</span>
  {!collapsed && "Schedule Meeting"}
</button>
      {/* BOTTOM */}
      <div className="admin_bottom">
        <button
          className="admin_logout"
          onClick={() => {
            localStorage.removeItem("adminToken");
            localStorage.removeItem("adminName");
            navigate("/admin-login");
          }}
        >
          <i className="icon">⏻</i>

          {!collapsed && <span>Logout</span>}
        </button>
      </div>
  {showMeetingModal && (
  <div
    className="meeting-overlay"
    onClick={() => setShowMeetingModal(false)}
  >
    <div
      className="meeting-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="meeting-header">
        <h2>📹 Schedule Meeting</h2>

        <button
          onClick={() => setShowMeetingModal(false)}
        >
          ✕
        </button>
      </div>

    <form
  onSubmit={(e) => {
    e.preventDefault();

    alert("Meeting Scheduled Successfully!");

    // Backend API will be called here later

    setShowMeetingModal(false);
  }}
>

        <input
          type="text"
          placeholder="Meeting Title"
        />

        <textarea
          placeholder="Meeting Description"
          rows="4"
        ></textarea>

        <div className="meeting-grid">

          <input type="date" />

          <input type="time" />

        </div>

        <input
          type="text"
          placeholder="Department / Semester"
        />

        <input
          type="url"
          placeholder="Google Meet / Zoom Link"
        />

        <button
          type="submit"
          className="meeting-submit"
        >
          🚀 Send Notification to Students
        </button>

      </form>
    </div>
  </div>
)}
    </div>
  );
};

export default Sidebar;